import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom';
import ScrollToBottomStore from '../../store/ScrollToBottomStore';
import { ArrowDown } from 'lucide-react';
import { scrollToBottom } from '../../utils/scrollHelpers';

const ScrollToBottomButton = ({ anchorRef }) => {
    const showScrollButton = ScrollToBottomStore(
      (state) => state.showScrollButton
    );
    const [position, setPosition] = useState({ bottom: 0, left: 0 });

    useEffect(() => {
      if (showScrollButton && anchorRef?.current) {
        const rect = anchorRef.current.getBoundingClientRect();
        setPosition({
          bottom: window.innerHeight - rect.top + 8,
          left: rect.left + rect.width / 2
        });
      }
    }, [showScrollButton, anchorRef]);

    if (!showScrollButton) return null;

    return createPortal(
      <button
        onClick={() => scrollToBottom(true)}
        style={{
          position: 'fixed',
          bottom: `${position.bottom}px`,
          left: `${position.left}px`,
          transform: 'translateX(-50%)',
          zIndex: 9999
        }}
        className="border-[0.5px] opacity-100 h-[26px] w-[26px] flex justify-center items-center rounded-full shadow-md transition bg-button-scroll-surface border-button-scroll-border"
      >
        <ArrowDown
          className="w-3.5 h-3.5 text-button-control-text"
        />
      </button>,
      document.body
    );
};

export default ScrollToBottomButton
